import Warning from "./Warning";

export default function Banner() {
  return (
    <>
      {/*
        Make sure you add some bottom padding to pages that include a sticky banner like this to prevent
        your content from being obscured when the user scrolls to the bottom of the page.
      */}
      <div className="fixed inset-x-0 bottom-0 z-50 bg-gray-900 shadow-lg">
        {/* <Warning/>   */}
        <div className="mx-auto max-w-8xl px-2 sm:px-3.5">
          <div className="flex items-center justify-center py-2.5 sm:py-3">
            <p className="text-center text-xs leading-5 text-white sm:text-sm sm:leading-6">
              <strong className="font-semibold">Stock market </strong>
              <svg
                viewBox="0 0 2 2"
                className="mx-1 inline h-0.5 w-0.5 fill-current sm:mx-2"
                aria-hidden="true"
              >
                <circle cx={1} cy={1} r={1} />
              </svg>
              <span className="inline-block">
                Stock markets are subject to risks. Disciplined and informed investing, with a long-term approach, helps navigate volatility and build wealth over time.
                <span className="ml-1 inline-block animate-pulse">✨</span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
